import React, { Component } from 'react'
import { Header, PageWrapper, DefaultText, XMText, XLMText, FlexWrapper } from '../components'
import Cookies from 'js-cookie'
class SingleFAQ extends Component {
  state = {}

  render() {
    const native = this.props.location.pathname.indexOf('native') > -1
    const {
      match: {
        params: { tab }
      }
    } = this.props
    return (
      <React.Fragment>
        {!native && (
          <Header
            title={'FAQ'}
            icon="arrowBack"
            onClickBack={() =>
              Cookies.get('prevPath')
                ? this.props.history.replace(Cookies.get('prevPath'))
                : this.props.history.goBack()
            }
            color="#fff"
          />
        )}
        <PageWrapper viewPadding={native ? '5.4% 3.9% 6%' : '22.4% 3.9% 6%'}>
          {tab === 'why-trust-greenchoice' && (
            <React.Fragment>
              <DefaultText color="#124b5f">
                I already don’t trust most food brands and labels, why should I trust GreenChoice?
              </DefaultText>
              <XMText color="#777777" padding="10px 0 0">
                Very important question - the following are reasons we feel you can and should trust us, but if you’re
                not convinced please shoot us a message via our Connect page and let us know!
              </XMText>
              <XMText color="#777777" padding="10px 0 0">
                1. We’re not making things up! We rely on data from existing authorities in personal and public health,
                environmental science, human rights, sustainable agriculture, and beyond. For more info on our data
                sources check out our GS System page.
              </XMText>
              <XMText color="#777777" padding="10px 0 0">
                2. We will always be honest with you about how we evaluate companies and their products, and we we will
                always be honest with you about how we make money and who pays us.{' '}
              </XMText>
              <XMText color="#777777" padding="10px 0 0">
                3. Our Founder and CEO Galen Karlan-Mason grew up in rural Vermont, raised by two former hippies in the
                woods. His parents built their house with ~14 friends and installed solar panels on their roof to heat
                their water, and just 2 years ago they installed additional panels to go 100% renewable. His family
                raises chickens for eggs and made a point to give their 7 hens more space than the hens have ever dared
                explore. His dad drives an electric car and an electric motorcycle. When growing up everything was
                recycled and lights were never left on after leaving a room. Galen’s place value on experiences, nature,
                personal relationships, kindness, education, and our responsibility to give back. Galen is the product
                of these values, and started GreenChoice to empower consumers with the knowledge to make vote with their
                dollars, because he believes companies are meant to work for our best interests. Galen hopes GreenChoice
                will leverage our collective buying power to push companies to act in our best interest and produce
                products that nurture - rather than harm - us and the planet.
              </XMText>
            </React.Fragment>
          )}
          {tab === 'make-money' && (
            <React.Fragment>
              <DefaultText color="#124b5f">How does GreenChoice make money?</DefaultText>
              <XMText color="#777777" padding="10px 0 0">
                We license our product attribute data and analytics to grocery retailers, food distributors, and product
                manufacturers, which they use to evaluate their own sales data for trends related to diet, health, and
                sustainability. We also work with health organizations and health departments to implement healthy
                eating tools and initiatives within their communities.
              </XMText>
              <XMText color="#777777" padding="10px 0 0">
                There is absolutely no sponsored content on the GreenChoice app, and we do not permit food
                manufacturers, retailers, or distributors to pay for listing.
              </XMText>
              {/* <FlexWrapper direction="row" viewPadding="10px 0 0">
                <XLMText>Retailers:</XLMText>{' '}
                <XMText color="#777777">&nbsp; 3%-5% of net sales earned from our users</XMText>
              </FlexWrapper>
              <FlexWrapper direction="row" viewPadding="10px 0 0">
                <XLMText>Brands:</XLMText>{' '}
                <XMText color="#777777">&nbsp;5%-7% of discounts redeemed by our users</XMText>
              </FlexWrapper> */}
            </React.Fragment>
          )}
          {tab === 'pbc-mean' && (
            <React.Fragment>
              <DefaultText color="#124b5f">
                What does the PBC mean? I usually see LLC or Corp. after a company name.
              </DefaultText>
              <XMText color="#777777" padding="10px 0 0">
                As a public benefit corporation (PBC), GreenChoice has a legal obligation to prioritize our public
                benefit to society and the environment alongside financial returns. Our public benefit as defined in our
                charter is, “to empower people to create a healthy, just and sustainable world.” We will do this by…
              </XMText>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>1. Empowering consumers to make informed choices:</XLMText>
                <XMText color="#777777">
                  1.a. By providing users with critical and honest information on the health implications, environmental
                  sustainability, and social responsibility of industries, companies, products and services.
                </XMText>
                <XMText color="#777777">1.b. By giving users feedback on the impact of their choices.</XMText>
                <XMText color="#777777">
                  1.c. By connecting users in ways that facilitate and inspire collective action.
                </XMText>
              </FlexWrapper>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>2. Conducting operations with integrity and transparency:</XLMText>
                <XMText color="#777777">
                  2.a. By publicly disclosing information on our scoring methodology and clearly defining and avoiding
                  potential conflicts of interest that could jeopardize the integrity of our GreenScores™.
                </XMText>
              </FlexWrapper>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>3. Fostering a work environment of integrity, courage, curiosity, and collaboration:</XLMText>
                <XMText color="#777777">
                  3.a. By creating a workplace in which we play big, praise diversity, seek truth, and recognize that
                  only together we will change the world.
                </XMText>
              </FlexWrapper>
            </React.Fragment>
          )}
          {tab === 'pbc-interest-policy' && (
            <React.Fragment>
              <DefaultText color="#124b5f">Does GreenChoice, PBC have a conflict of interest policy?</DefaultText>
              <XMText color="#777777" padding="10px 0 0">
                We are keenly aware that food and beverage companies may have a vested interest in influencing our
                company analyses and product scoring process, in order to earn higher GreenScores or gain favor in the
                eyes of our users. Consequently, we will do everything in our power to avoid perceived or real conflicts
                of interests. For this reason, GreenChoice we will review all business partnerships and customer
                relationships for any potential conflicts of interests based on the following guidelines.
              </XMText>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>There exists a perceived or real conflict of interest for GreenChoice if:</XLMText>
                <XMText color="#777777">1. A food or beverage company pays GreenChoice to score its products.</XMText>
                <XMText color="#777777">
                  2. A food or beverage company pays GreenChoice to use its GreenScores for advertising, marketing, or
                  promotional purposes.
                </XMText>
                <XMText color="#777777">
                  3. A food or beverage company or an executive at a food and beverage company has ownership in
                  GreenChoice or holds a seat on the board of GreenChoice.
                </XMText>
              </FlexWrapper>
            </React.Fragment>
          )}
          {tab === 'values-guide' && (
            <React.Fragment>
              <DefaultText color="#124b5f">What values guide the GreenChoice team?</DefaultText>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>Integrity</XLMText>
                <XMText color="#777777">1. Trust is not earned it is lost</XMText>
                <XMText color="#777777">2. Maintain truth unto its innermost parts.</XMText>
              </FlexWrapper>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>Curiosity</XLMText>
                <XMText color="#777777">1. Question everything at least twice</XMText>
                <XMText color="#777777">
                  2. There is always more than one side to the story (and often more than two).
                </XMText>
              </FlexWrapper>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>Courage</XLMText>
                <XMText color="#777777">1. Love the life you live</XMText>
                <XMText color="#777777">2. Be creative; do more with less.</XMText>
                <XMText color="#777777">3. Playing small does not serve the world (or yourself).</XMText>
              </FlexWrapper>
              <FlexWrapper justifyContent="center" viewPadding="10px 0 0">
                <XLMText>Collaboration</XLMText>
                <XMText color="#777777">1. Be proud of the dish you bring to the table</XMText>
                <XMText color="#777777">2. Instill in others a sense of self worth.</XMText>
                <XMText color="#777777">3. Only together can we change the world.</XMText>
              </FlexWrapper>
            </React.Fragment>
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default SingleFAQ



// WEBPACK FOOTER //
// ./src/pages/SingleFAQ.js